import React from 'react';
import { Box, Skeleton } from '@mui/material';

const BusinessDetailsSkeleton = () => (
  <Box>
    <Skeleton variant="rectangular" height={80} sx={{ mb: 2 }} />
    <Skeleton variant="rectangular" height={250} sx={{ mb: 2 }} />
    <Skeleton variant="rectangular" height={180} sx={{ mb: 2 }} />
    <Skeleton variant="rectangular" height={160} />
  </Box>
);

export default BusinessDetailsSkeleton;